"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileIcon = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FileIconsMap = require("./FileIconsMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FileIcon = _ref => {
  let {
    file,
    fileExtension
  } = _ref;
  const thumbnailHolder = (0, _react.useRef)();
  const defaultIcon = _FileIconsMap.FileIconsMap.default;
  const setThumbnailImage = (0, _react.useCallback)(thumbnailImage => {
    if (thumbnailHolder.current) {
      thumbnailHolder.current.style.backgroundImage = "url(".concat(thumbnailImage, ")");
    }
  }, []);
  if (_FileIconsMap.ImageFileExtensions.indexOf(fileExtension) !== -1) {
    const imageFileReader = new FileReader();
    imageFileReader.readAsDataURL(file);
    imageFileReader.onload = event => {
      setThumbnailImage(event.target.result);
    };
    return /*#__PURE__*/_react.default.createElement("span", {
      role: "presentation",
      "aria-hidden": true,
      className: "fileImageThumbnail"
    }, _FileIconsMap.FileIconsMap[fileExtension], /*#__PURE__*/_react.default.createElement("span", {
      className: "fileImageThumbnailHolder",
      ref: thumbnailHolder
    }));
  }
  if (_FileIconsMap.FileIconsMap[fileExtension]) {
    return /*#__PURE__*/_react.default.createElement("span", {
      role: "presentation",
      "aria-hidden": true,
      className: "fileImageThumbnail"
    }, _FileIconsMap.FileIconsMap[fileExtension]);
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "aria-hidden": true,
    className: "fileImageThumbnail"
  }, defaultIcon);
};
exports.FileIcon = FileIcon;
FileIcon.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  file: _propTypes.default.any,
  fileExtension: _propTypes.default.string
};